export default __webpack_public_path__ + "static/media/tag_clap_ko.be5bf464.gif";